<template>
    <v-card-text  class="mt-4" align="center">
        <div v-if="!disable_group">
            <div class="text-h6 ml-8 mr-8" align="left"><b>เลือกวันกลุ่มงานบริการ</b></div>
            <FragmentSelectGroup 
                class="ml-12 mr-12 mt-2"
                @ongroup="onGroup" 
                :station_code="station_code" 
                :have_group_0="false"
                ref="group" 
            ></FragmentSelectGroup>
        </div>
        <div class="text-h6 ml-8 mr-8" align="left"><b>เลือกวัน : {{ date }}</b></div>
        <div align="center" class="mt-2">
            <Calendar
                :columns="$screens({ default: 1, lg: 3 })"
                @dayclick="onDate"
                :available-dates="available_dates"
                :attributes='calendar_attrs'
                :locale="{id:$i18n.locale }"
            >
            </Calendar>
        </div>
        <div class="text-h6 mt-6 ml-8 mr-8" align="left"><b>เลือกช่วงเวลา</b></div>
        <div class="ml-12 mr-12 mt-2">
                <FragmentSelectTimeRange
                    @ontimestart="onTimestart"
                    @ontimeend="onTimeend"
                    :have_range_0="false"
                    v-if="timeslotlist.length==0"
                ></FragmentSelectTimeRange>
                <v-select
                    :value="timeslot"
                    @change="onTimeslot"
                    :items="timeslotlist_items"
                    item-text="text"
                    item-value="val"
                    label="ช่วงเวลา"
                    return-object
                    outlined
                    dense
                    v-else
                ></v-select>
        </div>
        <div class="text-h6 mt-6 ml-8 mr-8" align="left" v-if="group_extranote_list.length>0"><b>หมายเหตุ</b></div>
        <v-list align="left" class="ml-12 mr-12 mb-4" v-if="!disable_group">
            <v-list-item
                v-for="(item, index) in group_extranote_list"
                :key="index"
            >
                <v-row class="mb-n4">
                    <v-col cols="12" md="2">{{item.extranote_label}} : </v-col>
                    <v-col cols="12" md="10">
                        
                            <v-list>
                                <v-row>
                                <v-list-item
                                    v-for="(item2, index2) in item.extranote_value"
                                    :key="index2"
                                    :class="'col-md-'+ Math.floor(10/item.extranote_value.length) +' col-12 mb-n8 mt-n8'"
                                >   
                                    <v-text-field v-if="item2[0]=='{' && item2[item2.length-1]=='}'"
                                        @change="(val)=>{changeExtranote(index,index2,val)}"
                                        outlined
                                        dense
                                        :label="item2.substring(1,item2.length-1)"
                                        hide-details
                                    />
                                    <div v-else-if="item2[0]=='[' && item2[item2.length-1]==']'">
                                        <v-select
                                            @change="(val)=>{changeExtranote(index,index2,val)}"
                                            :items="item2.substring(1,item2.length-1).split(',')"
                                            single-line
                                            outlined
                                            dense
                                            hide-details
                                        ></v-select>
                                    </div>
                                    <div v-else class="align-self-center">{{item2}}</div>
                                </v-list-item>
                                <v-spacer></v-spacer>
                                </v-row>
                            </v-list>
                        
                    </v-col>
                </v-row>
            </v-list-item>
        </v-list>
    </v-card-text>
</template>

<script>

import FragmentSelectGroup from './FragmentSelectGroup.vue'
import FragmentSelectTimeRange from '@/components/Common/FragmentSelectTimeRange.vue'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import config from '@/../config.js'
import axios from 'axios';
import Staff from '@/model/instance/Staff.js'

export default {
    props: {station_code:[String, Number],disable_group: {type: Boolean,required: false,default: false}},
    components: {
        FragmentSelectGroup
        ,FragmentSelectTimeRange
        ,Calendar
    },
    data: () => ({
        date: null,
        group_id: null,
        /*group_id: null,
        group_name: null,
        timestart: null,
        timeend: null,*/
        calendar_attrs : []
        ,available_dates : []
        ,group_calendars : []
        ,available_group : []
        ,timeslotlist : []
        ,timeslotlist_items : []
        ,timeslot : {}
        ,group_extranote_list:[]
        ,extranote_list:[]
    }),
    mounted() {
        this.reset()
        /*var date = new Date()
        date.setHours(date.getHours()+7) 
        this.onDate({id:date.toISOString().substring(0,10)})*/
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.appointment.manage.get_calendar,{station_code:this.station_code},{ headers: Staff.getTokenHeader()})
        .then(response => {
            this.available_dates = []
            this.calendars = response.data.calendars
            this.calendars.forEach(car=>{
                car.calendar.forEach(c=>{
                    if(!c.is_close){
                        var datee = new Date(c.datee);
                        datee.setHours(datee.getHours() + 7);
                        this.available_dates.push(datee.toISOString().substring(0,10));
                    }
                })
            })
            //res.json({calendars:Array.from(new Set(result))})
            this.$store.commit('finishLoading',que)
        })
    },
    methods: {
        getWeekdayItem(d){
            return this.weekday_items[parseInt(d.weekday)]
        },
        getMonthItem(d){
            return this.month_items[parseInt(d.month)]
        },
        reset(){
            /*this.group_id = null
            this.group_name = null*/
            this.timeslot = {}
            this.updateTimeslot()
        },
        onDate(date){
            this.date = date.id
            this.calendar_attrs.forEach((v,i,arr)=>{
                arr[i].highlight = false
            })
            this.calendar_attrs.push({highlight: true,dates: date.id})
            var available_group = []
            this.calendars.forEach(car=>{
                car.calendar.forEach(c=>{
                    if(!c.is_close){
                        var datee = new Date(c.datee);
                        datee.setHours(datee.getHours() + 7);
                        if(date.id==datee.toISOString().substring(0,10)){
                            available_group.push(car.group_id)
                        }
                    }
                })
            })
            if(!this.disable_group){
                this.$refs.group.filtergroup(available_group)
                this.updateTimeslot()
            }
            this.$emit('ondate',date.id);
        },
        onGroup(group){
            //this.group_id = group.group_id
            //this.group_name = group.group_name
            this.group_id = group.group_id
            this.updateTimeslot()
            this.$emit('ongroup',group);

            console.log(this.calendars)
            this.available_dates = []
            this.calendars.forEach(car=>{
                if(car.group_id == this.group_id){
                    car.calendar.forEach(c=>{
                    if(!c.is_close){
                        var datee = new Date(c.datee);
                        datee.setHours(datee.getHours() + 7);
                        this.available_dates.push(datee.toISOString().substring(0,10));
                    }
                })
                }
            })

            var que2 = this.$store.commit('addLoading')
                axios
                .post(config.api.url.public.appointment.get_groupextranotelist,{group_id:this.group_id})
                .then(response => {
                    this.group_extranote_list = []
                    this.extranote_list = []
                    this.$emit('onextranote',[]);
                    response.data.forEach(extranote=>{
                        var vallist = []
                        var old_vallist = []
                        var tmp = ""
                        for (const c of extranote.extranote_value){
                            if(c=="["||c=="{"){
                                if(tmp.length>0){
                                    vallist.push(tmp)
                                    old_vallist.push(tmp)
                                    tmp = ""
                                }
                            }
                            tmp = tmp + c                            
                            if(c=="]"||c=="}"){
                                if(tmp.length>0){
                                    vallist.push(tmp)
                                    old_vallist.push(tmp)
                                    tmp = ""
                                }
                            }
                        }
                        if(tmp.length>0){
                            vallist.push(tmp)
                            old_vallist.push(tmp)
                            tmp = ""
                        }
                        this.group_extranote_list.push({
                            "extranote_name" : extranote.extranote_name
                            ,"extranote_label" : extranote.extranote_label
                            ,"extranote_value" : old_vallist
                        })
                        this.extranote_list.push({
                            "extranote_name" : extranote.extranote_name
                            ,"old_extranote_value" : old_vallist
                            ,"extranote_value" : vallist
                        })
                    })
                    this.$store.commit('finishLoading',que2)
                })
        },
        changeExtranote(extranote_index,value_index,value){
            var extranote_value = this.extranote_list[extranote_index].extranote_value
            extranote_value[value_index] = value
            if(value.length==0){
                extranote_value[value_index] = this.extranote_list[extranote_index].old_extranote_value[value_index]
            }
            this.extranote_list[extranote_index].extranote_value = extranote_value
            var extranote = this.extranote_list.filter(e=>e.old_extranote_value.join(' ')!=e.extranote_value.join(' '))
            extranote = extranote.map(e=>{ return {
                "extranote_name" : e.extranote_name
                ,"extranote_value" : e.extranote_value.join(' ')
            }})
            this.$emit('onextranote',extranote);
        },
        updateTimeslot(){
            if(this.date != null && this.group_id != null){
                var que = this.$store.commit('addLoading')
                axios
                .post(config.api.url.manage.appointment.manage.get_timeslot,{group_id:this.group_id,date:this.date},{ headers: Staff.getTokenHeader()})
                .then(response => {
                    this.timeslotlist = response.data.timeslotlist
                    this.timeslotlist_items = []
                    this.timeslotlist_items = response.data.timeslotlist.map((i)=>{
                        var timestartstr = '0000' + i.timestart;
                        timestartstr = timestartstr.substring(timestartstr.length-4,timestartstr.length)
                        var timeendstr = '0000' + i.timeend;
                        timeendstr = timeendstr.substring(timeendstr.length-4,timeendstr.length)
                        return {
                            text: timestartstr.substring(0,2) + ':' + timestartstr.substring(2,4) + " - " + timeendstr.substring(0,2) + ':' + timeendstr.substring(2,4) + " " + i.appointment + "/" + i.seat
                            ,val : i
                            ,disabled : i.appointment >= i.seat
                        }
                    })
                    this.$store.commit('finishLoading',que)
                })
            }
        },
        onTimeslot(val){
            this.$emit('ontimestart',val.val.timestart);
            this.$emit('ontimeend',val.val.timeend);
        },
        onTimestart(timestart){
            //this.timestart = timestart
            this.$emit('ontimestart',timestart);
        },
        onTimeend(timeend){
            //this.timeend = timeend
            this.$emit('ontimeend',timeend);
        }
    }

}
</script>